import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-pricing-card',
  templateUrl: './pricing-card.component.html',
  styleUrls: ['./pricing-card.component.css']
})
export class PricingCardComponent {
@Input() packageName: string =" "; 
@Input() packageServices: Array<string> =[];
@Input() packagePrice!: string;
@Input() packageShowPrice:boolean=false;


}
